export default "__VITE_ASSET__33883109__"